
//create gallery angular Module
angular.module('gallery', []);